
<div
  :class="['dropdown', { disabled, 'overflow-hidden': overflowHidden }]"
  v-click-outside="close"
  @keydown.esc="close"
>
  <slot />

  <div
    v-show="active"
    class="dropdown-content"
    :class="[align, { flex }]"
  >
    <slot name="menu" />
  </div>
</div>
